const taxRecordsHeader = [
  {
    text: 'Year',
    value: 'taxYear',
    align: 'left',
    sortable: false,
  },
  { text: 'Tax ID', value: 'taxId' },
  { text: 'Name', value: 'ownerName' },
  {
    text: 'Total Tax',
    value: 'totalTax',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Payment Date',
    value: 'payDate',
    // formatter: 'shortDate', // disabled: original-type rows have undefined payDate; toShortDate(undefined) renders today
    sortable: false,
  },
  {
    text: 'Amount Paid',
    value: 'totalPaid',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },
  {
    text: 'Amount Due',
    value: 'totalDue',
    align: 'right',
    formatter: 'amount',
    sortable: false,
  },

];

const exemptMfgBelowHeader = [

  {
    text: 'Priority', value: 'priority', sortable: false,
  },
  {
    text: 'Expected Amount', value: 'totalExpectedAmount', sortable: false, align: 'right', formatter: 'amount',
  },
  {
    text: 'Apportioned Amount', value: 'totalApportionmentAmount', sortable: false, align: 'right', formatter: 'amount',
  },
  {
    text: 'Collected Amount', value: 'totalCollectedAmount', sortable: false, align: 'right', formatter: 'amount',
  },
  {
    text: 'Uncollected Amount', value: 'totalUnCollectedAmount', sortable: false, align: 'right', formatter: 'amount',
  },
];

export { exemptMfgBelowHeader, taxRecordsHeader };
